export default __webpack_public_path__ + "static/media/image.townchic-global-ventures-pvt-ltd-.7149b473.png";